import Alpine from 'alpinejs';
import scrollIntoView from 'scroll-into-view-if-needed';


/* Primitive extensions */

Object.defineProperty(Number.prototype, 'toLocaleStringWithContext', {
    value(locale, options) {
        if (parseInt(this) == this) {
            return this.toLocaleString(locale, {minimumFractionDigits: 0, maximumFractionDigits: 0});
        } else {
            return this.toLocaleString(locale, options);
        }
    }
});

Object.defineProperty(Object.prototype, 'pop', {
    configurable: true,
    enumerable: false,
    writable: false,

    value: function (key) {
        const rv = this[key];
        delete this[key];
        return rv;
    }
});


/* ES5 compatibility functions, transpiled by Babel */

global._defineProperty = function(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
};

global._objectSpread = function(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
};

global._toPrimitive = function(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
};

global._toPropertyKey = function(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
};

global._typeof = function(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
};

global.ownKeys = function(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
};


/* Custom functions */

global.$ = function(id) {
    return document.getElementById(id);
};

global.$component = function(elemOrId) {
    const elem = (typeof elemOrId === 'string') ? document.getElementById(elemOrId) : elemOrId;
    if (!elem) return;
    // Data stack indices are child → parent(s)
    return Alpine.closestDataStack(elem)[0];
};

global.$components = function(selector, startingElemOrId) {
    const startingElem = startingElemOrId ? ((typeof startingElemOrId === 'string') ? document.getElementById(startingElemOrId) : startingElemOrId) : document;
    if (!startingElem) return;

    let components = [];

    startingElem.querySelectorAll(selector)?.forEach(elem => {
        components.push($component(elem));
    });

    return components;
};

global.$dispatchTo = function(elem, eventName, detail={}) {
    elem.dispatchEvent(
        new CustomEvent(eventName, {
            detail: detail,
            bubbles: true,
            composed: true,
            cancelable: true,
        })
    );
};

global.$pushState = function(state, _, url) {
    if (url === undefined) url = window.location.href;
    history.pushState(state, '', url);
};

global.asLocale = function(value, locale, minDigits, maxDigits) {
    if (value === '' || isNaN(value)) return '';
    return parseLocaleFloat(value, locale).toLocaleString(locale || 'en', {minimumFractionDigits: minDigits || 2, maximumFractionDigits: maxDigits || 2});
}

global.isNumeric = function(value) {
    return !isNaN(value - parseFloat(value));
};

global.nextDayOfMonth = function(day) {
    day = parseInt(day);
    if (isNaN(day)) return null;

    let next = new Date();
    let today = next.getDate();

    // Get actual last day of month
    if (day == 0) day = (new Date(next.getFullYear(), next.getMonth() + 1, 0)).getDate();
    next.setDate(day);

    // If we have passed, or are on, "day" then bump by a month
    if (today >= day) next.setMonth(next.getMonth() + 1);

    return next;
};

global.parseFloatOrInt = function(value) {
    if (parseInt(value) == value) {
        return parseInt(value);
    } else {
        return parseFloat(value);
    }
};

global.parseLocaleFloat = function(value, locale) {
    // TODO: thousand separator removal based on locale
    value = String(value).replace(',', '');
    return parseFloat(value);
};

global.focusElem = function(elem, flash=false) {
    const hasScroll = document.body.scrollHeight > document.body.clientHeight;
    if (!hasScroll && !flash) return;

    scrollIntoView(elem, {
        behavior: 'smooth',
        scrollMode: 'if-needed',
        block: 'center',
    });

    if (flash) {
        elem.classList.add('bg-yellow-50');
        setTimeout(() => {
            elem.classList.remove('bg-yellow-50');
        }, 1500);
    }
};

global.setComponentAttribute = function(componentId, attr, value) {
    let elem = $component(componentId);
    elem[attr] = value;
};
